
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import KeysTable from "@/components/users/KeysTable.vue";

@Component({
  components: { KeysTable},
})
export default class UserKeyAccessTab extends Vue {

  @Prop({ default: null })
  public userId: number;

  private keys: object[] = [];
  private loading: boolean = false;
  private count: number = 0;

  private async getKeys(pagination: any): Promise<void> {
    this.loading = true;
    const p: Array<Promise<any>> = [
      this.$store.dispatch("users/getMyKeys", {
        id: this.userId,
        query: {
          role: "GUEST",
          statuses: pagination.statuses,
          archived: false,
          page: pagination.page,
          itemsPerPage: pagination.itemsPerPage,
        },
      }),
      this.$store.dispatch("users/getLateKeys", {
        id: this.userId,
      }),
    ];
    await Promise.all(p)
      .then(([keys, lateKeys]) => {
        this.keys = [
          ...lateKeys.keys,
          ...keys.keys,
        ];
        this.count = keys.count + lateKeys.count;
      }).finally(() => {
        this.loading = false;
        this.$emit("loaded");
      });
  }
}
